import React from 'react';
import './Partnership.css';
import Navbar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer';
import P1 from '../Components/Section/P1';

const Partnership = () => {
    return (
      <div className="partnership-container">
        <Navbar/>
        <P1/>
        <Footer/>
      </div>
    );
}

export default Partnership;